import React from "react";
import "./VerifyPin.scss";
import {MDBBox, MDBIcon, MDBTypography} from "mdbreact";
import cogoToast from "cogo-toast";
import VerifyPinMutation from "../../mutations/VerifyPinMutation";
import LoginWithPinMutation from "../../mutations/LoginWithPinMutation";
import {setLoginStep, userLogin} from "../../Actions";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {Slide} from "react-reveal";
import AddNotificationTokenMutation from "../../mutations/AddNotificationToken";
import {Fade} from "@material-ui/core";
import {assetUrl} from "../../serviceApi";

const rocket = assetUrl+"images/animation_rocket.svg";
const cloud = assetUrl+"images/animation_cloud.svg";
const AngleLeft = assetUrl+"images/login-arrow-left.svg";
const CloseIcon = assetUrl+"images/login-cross-nav.svg";
const eye = assetUrl+'images/eye_open.svg'
const eyelash = assetUrl+'images/eyeClose.svg'

class VerifyPin extends React.Component {
	state = {
		pin: "",
		loading: false,
		trigger: false,
		hideRocket: true,
		pinVerified: false,
		show_password: false
	}

	componentDidMount() {
		this.setState({...this.state, trigger: true, pinVerified: false})
		this.props.forgetPin(false)
	}

	handleInputChange = (e, feild) => {
		let value;
		if (feild === "pin") {
			value = (e.target.validity.valid) ? e.target.value : this.state.pin;
		} else {
			value = e.target.value;
		}
		this.setState({
			[feild]: value
		})
	}

	handleSubmit = (e) => {
		e.preventDefault()
		if (this.props.user_details.refreshToken === "" || this.props.user_details.refreshToken === null) {
			this.loginWithoutToken();
		} else {
			this.loginWithRefreshToken();
		}

	}

	loginWithoutToken = () => {

		let data = {
			mobileNumber: "+91" + this.props.user_details.mobileNumber,
			pin: this.state.pin
		}
		let scope = this;
		if (this.state.pin === "") {
			cogoToast.warn("please fill valid pin", {position: 'top-center'});
		} else if (this.state.pin.length < 4) {
			cogoToast.warn("pin number should be 4 digits", {position: 'top-center'});
		} else {
			this.setState({
				loading: true
			})
			VerifyPinMutation(data, function (response) {
				scope.setState({
					loading: false
				})
				if (response.verifyPin.token && response.verifyPin.error === false) {
					scope.setState({hideRocket: false})
					setTimeout(() => {
						// cogoToast.success(response.verifyPin.message, { position: 'top-center'});
						scope.setUserData(response.verifyPin.token, response.verifyPin.refreshToken, response.verifyPin.user);
						let notification_token = localStorage.getItem("notification-token");
						if (notification_token) {
							scope.sendNotificationToken(notification_token);
						} else {
							// scope.props.history.push("/home");
							scope.props.completeLogin();
						}
					}, 2000)

				} else {
					cogoToast.error(response.verifyPin.message, {position: 'top-center'});
				}
			}, function (err) {
				scope.setState({
					loading: false
				})
				cogoToast.error(err, {position: 'top-center'});
			});
		}
	}

	loginWithRefreshToken = () => {

		let data = {
			mobileNumber: "+91" + this.props.user_details.mobileNumber,
			pin: this.state.pin,
			refreshToken: this.props.user_details.refreshToken
		}
		let scope = this;
		if (this.state.pin === "") {
			cogoToast.warn("please fill valid pin", {position: 'top-center'});
		} else if (this.state.pin.length < 4) {
			cogoToast.warn("pin number should be 4 digits", {position: 'top-center'});
		} else {
			this.setState({
				loading: true
			})
			LoginWithPinMutation(data, function (response) {
				scope.setState({
					loading: false
				})
				if (response.loginWithPin.token && response.loginWithPin.error === false) {

					scope.setState({hideRocket: false})
					setTimeout(() => {
						// cogoToast.success(response.loginWithPin.message, { position: 'top-center'});
						scope.setUserData(response.loginWithPin.token, response.loginWithPin.refreshToken, {});
						let notification_token = localStorage.getItem("notification-token");
						if (notification_token) {
							scope.sendNotificationToken(notification_token);
						} else {
							// scope.props.history.push("/home");
							scope.props.completeLogin();

						}
					}, 2000)

				} else {
					cogoToast.error(response.verifyPin.message, {position: 'top-center'});
				}
			}, function (err) {
				scope.setState({
					loading: false
				})
				cogoToast.error(err, {position: 'top-center'});
			});
		}
	}
	setUserData = (token, refreshToken, user) => {
		let data = {
			user_details: {
				mobileNumber: this.props.user_details.mobileNumber,
				token: token,
				refreshToken: refreshToken,
				user: user
			},
			logged_in: true,
		}
		localStorage.setItem("token", token);
		localStorage.setItem("refreshToken", refreshToken);
		this.props.addUserData(data);
		this.props.setLoginStep(0);
		this.props.handleLoginSteps(0);
	}

	goToPreviousPage = () => {
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
	}

	togglePassword = () => {
		this.setState({
			show_password: !this.state.show_password
		})
	}
	forgetPinRedirection = () => {
		this.props.forgetPin(true)
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
	}
	sendNotificationToken = (token) => {
		let scope = this;
		AddNotificationTokenMutation(token, function (response) {
			// scope.props.history.push("/home");
			scope.props.completeLogin();

		}, function (err) {
			console.log(err);
		});
	}

	render() {
		//hide rocket before animate
		// setTimeout(()=>{
		// 	this.setState({...this.state,hideRocket:false})
		// },1000)

		return (
			<MDBBox
				className="verify-password-form-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				<MDBBox>
					<MDBBox className="d-flex justify-content-between align-items-center pb-3">
						<img src={AngleLeft} alt={"AngleLeft"} onClick={this.goToPreviousPage}/>
						<p className={"mb-0 login-text"}>Log In</p>
						<img src={CloseIcon} alt={"CloseIcon"} onClick={this.goToPreviousPage}/>
					</MDBBox>
					{/*<Slide right cascade opposite when={this.state.trigger}>*/}
						<MDBBox className={'elipse-section'}>
							{
								this.state.hideRocket ? <>
									<img src={rocket} alt={"altImage"} className={"rocket-non-animate"}/>
									{/*<img src={cloud} alt={"altImage"} className={"cloud animate__animated animate__zoomIn animate__delay-1s"}/>*/}
								</> : <>
									<img src={rocket} alt={"altImage"} className={"rocket"}/>
									<img src={cloud} alt={"altImage"}
									     className={"cloud animate__animated animate__zoomIn animate__delay-1s"}/>
								</>
							}

						</MDBBox>
					{/*</Slide>*/}
					<div className={"form-section"}>
						{/*<Slide right cascade opposite when={this.state.trigger}>*/}
							<MDBBox className="create-password-form-section pt-4">

								<MDBTypography tag="h4" className="title">Enter Your Pin</MDBTypography>

								{/*<MDBTypography tag="p" className="description">This will be asked while opening the app</MDBTypography>*/}
								<form>
									<div className={"password-input-section"}>
										{
											this.state.show_password === true &&
											<input type={"number"}
												   pattern="[0-9]*"
												   maxLength="4"
												   inputMode={"numeric"}
												   className="form-control form-control-md my-3"
												   placeholder="Pin"
												   value={this.state.pin}
												   onKeyDown={(e) => {
													   if (e.key === 'Enter') {
														   this.handleSubmit(e);
													   }
												   }}
												   onChange={(e) => this.handleInputChange(e, "pin")}
												   onInput={(e) => this.handleInputChange(e, "pin")}
											/>
										}
										{
											this.state.show_password === false &&
											<input type={"password"}
												   pattern="[0-9]*"
												   maxLength="4"
												   inputMode={"numeric"}
												   className="form-control form-control-md my-3"
												   placeholder="Pin"
												   value={this.state.pin}
												   onKeyDown={(e) => {
													   if (e.key === 'Enter') {
														   this.handleSubmit(e);
													   }
												   }}
												   onChange={(e) => this.handleInputChange(e, "pin")}
												   onInput={(e) => this.handleInputChange(e, "pin")}
											/>
										}


										<img alt={"alt"} src={this.state.show_password === true ? eye : eyelash}
										     className={"eye-icon"} onClick={this.togglePassword}/>
									</div>
								</form>
								<div className={"text-right"}>
									<p className={"forgot-pin-text my-2"} onClick={this.forgetPinRedirection}>Forgot
										pin?</p>
								</div>
							</MDBBox>
						{/*</Slide>*/}
					</div>

				</MDBBox>
				<button className="btn submit-btn m-0  text-white my-4"
				        onClick={(e) => this.handleSubmit(e)}
				        id={"submitButton-verify"}
				        disabled={this.state.loading}

				>
					Log In
					<MDBIcon icon="angle-right" className="mx-2"/>
				</button>
			</MDBBox>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
})
const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(VerifyPin);
